import { PasswordSetParams } from 'store/modules/user/actions';

export interface Errors {
	password: string;
	passwordConfirm: string;
	recaptchaToken?: string;
}

export interface PasswordVisibility {
	password: boolean;
	passwordConfirm: boolean;
}

export enum InputTypes {
	Text = 'text',
	Password = 'password',
}

export interface ParentProps {
	localeData?: LocaleData | any;
	onSuccess?: () => any;
}

export interface Props extends ParentProps {
	actions: {
		passwordSet: (params: PasswordSetParams) => Promise<any>;
	};
}

export interface LocaleData {
	headline: string;
	paragraph: string;
	form: {
		inputLabel: string;
		buttonLabel: string;
	};
}
